import url from './url';



export default url(() => '/config-visualize/hash');
